export const environment = {
  production: false,
  oldOfferToolUrl:
    'https://ux-vpp-kundenportal-dev.azurewebsites.net/direktvermarktung/angebot-anfordern/?mandant=123db11f-de95-4037-9691-8fac6f9bf02a',
  newOfferToolUrl: 'https://indicative-offer-dev.interconnector.de',
  allowedParentHosts: ['interconnector.de', 'localhost'],
  parentOrigin: '*',
};
